import { OnboardingTabConfig, TenantCreationRequest } from '@/lib/dtos';

// Local "rascunho ao vivo" state used only to render the iPhone mockup —
// never the source of truth for persisted data (see design.md's
// OnboardingPreviewContext section).
export interface OnboardingPreviewState {
  appName: string | null;
  appIconUrl: string | null;
  storePlatform: string | null;
  tabs: OnboardingTabConfig[] | null;
  accentColor: string | null;
  /**
   * `key` of the tab currently being edited in TabBarConfigPage, so the
   * mockup can highlight that same tab as the active one — has no
   * persisted equivalent, always starts `null` (see `previewStateFromPersisted`).
   */
  activeTabKey: string | null;
  notificationPreviewTitle: string | null;
  notificationPreviewBody: string | null;
}

export function previewStateFromPersisted(
  persisted: TenantCreationRequest
): OnboardingPreviewState {
  return {
    appName: persisted.appName,
    appIconUrl: persisted.appIconUrl,
    storePlatform: persisted.storePlatform,
    tabs: persisted.tabs,
    accentColor: persisted.accentColor,
    activeTabKey: null,
    notificationPreviewTitle: persisted.notificationPreviewTitle,
    notificationPreviewBody: persisted.notificationPreviewBody,
  };
}

// Persisted TCR fields are the base; local overrides win field-by-field
// whenever present (not `undefined`) — this is a partial merge, not a full
// replace of the previous state.
export function mergePreviewState(
  persisted: TenantCreationRequest,
  overrides: Partial<OnboardingPreviewState>
): OnboardingPreviewState {
  const base = previewStateFromPersisted(persisted);

  return {
    appName: overrides.appName !== undefined ? overrides.appName : base.appName,
    appIconUrl:
      overrides.appIconUrl !== undefined
        ? overrides.appIconUrl
        : base.appIconUrl,
    storePlatform:
      overrides.storePlatform !== undefined
        ? overrides.storePlatform
        : base.storePlatform,
    tabs: overrides.tabs !== undefined ? overrides.tabs : base.tabs,
    accentColor:
      overrides.accentColor !== undefined
        ? overrides.accentColor
        : base.accentColor,
    activeTabKey:
      overrides.activeTabKey !== undefined
        ? overrides.activeTabKey
        : base.activeTabKey,
    notificationPreviewTitle:
      overrides.notificationPreviewTitle !== undefined
        ? overrides.notificationPreviewTitle
        : base.notificationPreviewTitle,
    notificationPreviewBody:
      overrides.notificationPreviewBody !== undefined
        ? overrides.notificationPreviewBody
        : base.notificationPreviewBody,
  };
}
